import { Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';
import { createElement, FC } from 'react';

type Props = { id: string } & TypographyProps;

const PublicId: FC<Props> = ({ id, ...props }) => {
  return <Typography {...props}>ID: {id}</Typography>;
};

export default PublicId;
